<template>
  <div>
    <div class="form-row">
      <div class="col-12">
        <p class="fs-20 mt-2">Faça seu cadastro usando as redes sociais</p>
        <div class="social-login-buttons my-3">
          <GoogleLoginButton class="mr-2" />
        </div>
        <div class="social-login-buttons my-3">
          <FacebookLoginButton></FacebookLoginButton>
        </div>
        <p class="fs-22 text-center font-weight-bold text-uppercase mb-4">Ou</p>
        <TextBasicData class="d-flex justify-content-center" />
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="choosetipo_cliente">Fazer cadastro como</label>
          <hr />
          <!--  -->
          <div id="content-radio">
            <b-form-radio-group
              id="choosetipo_cliente"
              name="choosetipo_cliente"
              @change="ErrorMessages.tipo_cliente = null"
            >
              <div class="format-radio">
                <b-form-radio v-model="Fields.tipo_cliente" :value="1">
                  <i class="fas fa-user"></i>
                  <a class="pointer"> Pessoa Física</a>
                </b-form-radio>
              </div>
              <div class="format-radio">
                <b-form-radio v-model="Fields.tipo_cliente" :value="2">
                  <i class="fas fa-building"></i>
                  <a class="pointer"> Pessoa Jurídica</a>
                </b-form-radio>
              </div>
            </b-form-radio-group>
          </div>
          <p
            v-if="ErrorMessages.tipo_cliente !== null"
            class="error-message text-danger"
          >
            {{ ErrorMessages.tipo_cliente }}
          </p>
        </div>
      </div>
      <div class="col-12" v-if="Fields.tipo_cliente !== null">
        <div class="form-group">
          <label for="nome">
            Nome {{ Fields.tipo_cliente === 1 ? 'completo' : 'da empresa' }}
          </label>
          <input
            class="form-control"
            v-model="Fields.nome"
            type="text"
            id="nome"
            name="nome"
            :placeholder="`Digite ${
              Fields.tipo_cliente === 1
                ? 'seu nome completo'
                : 'o nome da sua empresa'
            }`"
            @input="ErrorMessages.name = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.name !== null"
          >
            {{ ErrorMessages.name }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="telefone"> Telefone </label>
          <input
            type="tel"
            class="form-control"
            v-model="Fields.telefone"
            id="telefone"
            name="telefone"
            v-mask="['(##) #####-####', '(##) ####-####']"
            aria-describedby="Telefone para cadastro"
            placeholder="Digite seu telefone"
            @input="ErrorMessages.telephone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.telephone !== null"
          >
            {{ ErrorMessages.telephone }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <hr class="mt-4 mb-2" />
        <!-- <p class="font-weight-bold fs-24 text-center mb-3 c-orange">
          Dados de acesso <i class="fas fa-sign-in-alt ml-2"></i>
        </p> -->
        <TextAccess class="d-flex justify-content-center" />
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="email"> E-mail </label>
          <input
            type="email"
            class="form-control"
            id="emailField"
            name="email"
            v-model="Fields.email"
            aria-describedby="E-mail para acessar a plataforma"
            placeholder="Digite um E-mail para acessar a plataforma"
            @input="ErrorMessages.email = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email !== null"
          >
            {{ ErrorMessages.email }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <InputPassword
            :value.sync="Fields.password"
            :errorMessage.sync="ErrorMessages.password"
          />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <InputPassword
          :label="'Confirme sua senha'"
          :value.sync="confirmPassword"
          :errorMessage.sync="ErrorMessages.confirmPassword"
          :placeholder="'Digite novamente a sua senha'"
        />
      </div>
      <div class="col-12 mt-3">
        <div class="form-group d-flex justify-center">
          <b-form-checkbox
            id="termos"
            name="termsAndConditions"
            v-model="acceptedTermsAndConditions"
            @change="ErrorMessages.termsAndConditions = null"
          >
          </b-form-checkbox>

          <div class="font-weight-normal">
            Li e aceito os
            <span class="c-orange c-pointer" v-b-modal="'termos'"
              >termos e condições</span
            >
            e as
            <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'"
              >politicas de privacidade.</span
            >
          </div>
          <p
            v-if="ErrorMessages.termsAndConditions !== null"
            class="error-message text-danger"
          >
            {{ ErrorMessages.termsAndConditions }}
          </p>

          <p
            v-if="ErrorMessages.privacyPolicy !== null"
            class="error-message text-danger"
          >
            {{ ErrorMessages.privacyPolicy }}
          </p>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn bg-orange text-white btn-lg my-3"
      id="cadButton"
      @click="register()"
      v-on:click="captureEmail"
    >
      Cadastrar
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import FacebookLoginButton from '../../components/FacebookLoginButton.vue';
import GoogleLoginButton from '../../components/GoogleLoginButton.vue';
import makeToast from '../../mixins/makeToast';
import TextAccess from '../../components/Register/TextAccess.vue';
import TextBasicData from '../../components/Register/TextBasicData.vue';
import InputPassword from '../../components/Inputs/InputPassword.vue';
// import TermsAndConditions from '../../components/TermsAndConditions.vue';
// import PrivacyPolicy from '../../components/PrivacyPolicy.vue';

export default {
  name: 'ClientRegister',
  mixins: [makeToast],
  props: {
    cities: {
      type: Array,
      required: true,
    },
    states: {
      type: Array,
      required: true,
    },
  },
  components: {
    FacebookLoginButton,
    GoogleLoginButton,
    TextAccess,
    TextBasicData,
    InputPassword,
  },
  data() {
    return {
      Fields: {
        email: null,
        password: null,
        nome: null,
        telefone: null,
        tipo_cliente: null,
        telephone: null,
      },
      ErrorMessages: {
        email: null,
        password: null,
        confirmPassword: null,
        tipo_cliente: null,
        name: null,
        cpf: null,
        rg: null,
        cnpj: null,
        telephone: null,
        termsAndConditions: null,
        privacyPolicy: null,
      },
      confirmPassword: null,
      acceptedTermsAndConditions: false,
      acceptedPrivacyPolicy: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },
  watch: {
    'Fields.cep': function () {
      this.consultCep();
    },
  },
  methods: {
    captureEmail() {
      localStorage.setItem('emailField', this.Fields.email);
      const storage = localStorage.getItem('emailField');
      document.getElementById('setEmail').value = storage;
    },
    register() {
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('client/registerClient', this.Fields)
          .then(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Sucesso!', 'Cadastro realizado com sucesso!');
            setTimeout(() => {
              this.login(this.Fields.email, this.Fields.password);
            }, 1000);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Oopss!', 'E-mail já cadastrado!', 'danger');
            this.$bvModal.show('login');
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    validateFields() {
      let isValid = true;

      if (
        this.Fields.tipo_cliente === null ||
        (this.Fields.tipo_cliente !== 1 && this.Fields.tipo_cliente !== 2)
      ) {
        this.ErrorMessages.tipo_cliente =
          'Por favor, selecione o tipo de cadastro';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome)) {
        this.ErrorMessages.name = 'Nome inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.telefone)) {
        this.ErrorMessages.telephone = 'Telefone inválido';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email)) {
        this.ErrorMessages.email = 'Email inválido';
        isValid = false;
      }

      if (!this.$validate.password(this.Fields.password)) {
        this.ErrorMessages.password =
          'A senha precisa ter no mínimo 5 caracteres';
        isValid = false;
      }

      if (this.confirmPassword !== this.Fields.password) {
        this.ErrorMessages.confirmPassword = 'As senhas devem ser iguais';
        isValid = false;
      }

      if (!this.acceptedTermsAndConditions) {
        this.ErrorMessages.termsAndConditions =
          'Você precisa aceitar os termos e condições';
        isValid = false;
      }

      return isValid;
    },
    sendQuote(data) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('insertCotacao', data)
        .then(() => {
          localStorage.setItem('quote', null);
          this.$store.dispatch('endLoader');
          this.makeToast(
            'Sucesso',
            'Seu orçamento foi realizado com sucesso!',
            'success'
          );
          setTimeout(() => {
            if (this.dadosUsuario.tipo_usuario === 'Cliente') {
              this.$router.push({ name: 'cliente-solicitados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
              this.$router.push({ name: 'lojista-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
              this.$router.push({ name: 'profissional-meu-perfil' });
            } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
              this.$router.push({ name: 'representante-meus-dados' });
            }
          }, 1000);
        })
        .catch(() => {});
    },
    login(email, password) {
      const self = this;
      const data = {
        email,
        password,
      };
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('loadLogin', data)
        .then(() => {
          if (self.dadosUsuario !== null) {
            this.makeToast('Sucesso', 'Login realizado com sucesso!');

              const data = JSON.parse(localStorage.getItem('quote'));
              if(data != null) {
                data.usuario = self.dadosUsuario.id;
                self.sendQuote(data);
              }

              if (self.dadosUsuario.tipo_usuario === 'Cliente') {
                self.$router.push({ name: 'cliente-meus-dados' });
              } else if (self.dadosUsuario.tipo_usuario === 'Lojista') {
                self.$router.push({ name: 'lojista-meus-dados' });
              } else if (self.dadosUsuario.tipo_usuario === 'Profissional') {
                self.$router.push({ name: 'profissional-meu-perfil' });
              } else if (self.dadosUsuario.tipo_usuario === 'Representante') {
                self.$router.push({ name: 'representante-meus-dados' });
              } else if (self.dadosUsuario.tipo_usuario === 'Editor') {
                self.$router.push({ name: 'editor-meus-dados' });
              } else if (self.dadosUsuario.tipo_usuario === 'Administrador') {
                self.$router.push({ name: 'administrador-meus-dados' });
              }
            this.$store.dispatch('endLoader');
          } else {
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Oops',
              'Parece que seu email ou sua senha estão incorretos!',
              'danger'
            );
          }
        })
        .catch(() => {
          this.makeToast(
            'Sucesso',
            'Houve um problema na hora de realizar o login!',
            'danger'
          );
        });
    },
  },
};
</script>

<style scoped>
div.form-group label {
  font-weight: 700;
}

div.col-12 label {
  font-weight: 700;
}

.error-message {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #f8d7da;
  border-radius: 0 0 5px 5px;
}

.social-login-buttons {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  flex: 1 0 auto;
}

.format-radio {
  display: inline;
  margin: 10px;
  width: 150px;
  border-radius: 50px;
  text-align: center;
  transition-duration: 500ms;
}

</style>
